import { Injectable } from '@angular/core';
import * as errorCatalog from './authErrors.json';
declare const swal: any;

@Injectable({
  providedIn: 'root'
})
export class AuthErrorService {

  constructor() { }

  public showLoginErrorAlert(error){
    let err = errorCatalog.login.find(e => e.type == error.code);
    console.warn('error en login', error);
    swal({
      title: err.response.header,
      text: err.response.message,
      timer: 3000,
      showConfirmButton: false
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === 'timer') {
          console.log('I was closed by the timer');
        }
      }
    );
  }

  public showSignupErrorAlert(error){
    let err = errorCatalog.signup.find(e => e.type == error.code);
    console.warn('error en signup', error);
    swal({
      title: err.response.header,
      text: err.response.message,
      timer: 3000,
      showConfirmButton: false
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === 'timer') {
          console.log('I was closed by the timer');
        }
      }
    );
  }
}
